<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="10"
    viewBox="0 0 11 10"
    fill="none"
  >
    <path
      d="M10.6788 1.29606C10.9059 1.88368 10.5874 2.28599 9.97095 2.68229C9.47355 3.00204 8.83985 3.34844 8.16839 3.94066C7.51015 4.52122 6.86776 5.22048 6.29687 5.90872C5.72829 6.59417 5.24503 7.25121 4.90358 7.73769C4.68293 8.05206 4.375 8.52098 4.375 8.52098C4.15784 8.86456 3.76744 9.07251 3.34883 9.06729C2.93013 9.06207 2.54555 8.84459 2.3378 8.49557C1.80673 7.60339 1.39693 7.25106 1.20859 7.12449C0.70462 6.78583 0.113281 6.73573 0.113281 5.94653C0.113281 5.31977 0.642547 4.81168 1.29543 4.81168C1.75637 4.82869 2.18481 5.00998 2.56442 5.26507C2.80708 5.42814 3.06413 5.64381 3.3315 5.9277C3.64529 5.49969 4.02344 5.00588 4.44733 4.49485C5.06294 3.7527 5.78957 2.95655 6.56881 2.26927C7.33484 1.59364 8.22049 0.96122 9.15924 0.626848C9.77135 0.408822 10.4517 0.708437 10.6788 1.29606Z"
      fill="currentColor"
    />
  </svg>
</template>